import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router-dom';
import { compose, lifecycle, withHandlers } from 'recompose';
import { Table } from 'antd';
import styled from 'styled-components';
import moment from 'moment-timezone';

import { actions as transactionActions } from 'modules/transaction';
import { OrangeButton } from 'components/Core/Buttons';
import TransactionStatusTag from 'components/Transaction/TransactionStatusTag';
import { commaize } from 'utils/pricing';
import { loadingFromStore } from 'utils/HOCs/loading';
import config from 'config';

const { Column } = Table;

const StyledTable = styled(Table)`
  .ant-table {
    font-family: Montserrat !important;
  }
  .ant-table-tbody {
    background-color: ${props => props.theme.white};
  }
`;

const enhance = compose(
  connect(
    state => ({
      transactions: state.transaction.transactions
    }),
    {...transactionActions, push}
  ),
  withHandlers({
    onClickDetail: props => (bookingId) => {
      props.push(`/transaction/${bookingId}`);
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.getTransactions();
    }
  }),
  loadingFromStore('transaction.isLoadingTransactions')
);

const Transactions = props => {
  const { transactions } = props;
  return (
    <div>
      <StyledTable
        dataSource={transactions}
        bordered
        rowKey="_id"
      >
        <Column title="Booking Number" dataIndex="booking_number" width={170} />
        <Column
          title="Status"
          width={100}
          render={(text, record) => <TransactionStatusTag {...record} />}
        />
        <Column
          title="Trip Name"
          render={(text, record) => <a href={`${config.webPath}/trip/${record.trip_id.slug}`}>{record.trip_id.name}</a>}
        />
        <Column
          title="Created At"
          render={(text, record) => <p>{moment(record.created_at).format('D MMMM YYYY')}</p>}
          width={155}
        />
        <Column
          title="Trip Date"
          render={(text, record) => <p>{moment(record.trip_date).format('D MMMM YYYY')}</p>}
          width={155}
        />
        <Column
          title="Price"
          width={110}
          render={(text, record) => <p>{commaize(record.price.grand_total)}</p>}
        />
        <Column
          render={(text, record) => [
            <Link to={`/transaction/${record._id}`}>
              <OrangeButton key={record._id} icon="info-circle">Details</OrangeButton>
            </Link>
          ]}
          width={160}
        />
      </StyledTable>
    </div>
  );
};

export default enhance(Transactions);



// WEBPACK FOOTER //
// ./src/pages/Transaction/Transactions.js